<script>
import { pickBy } from 'lodash-es';

export default {
  name: 'FilterBox',
  props: {
    filters: {
      required: true,
    },
    tags: {
      type: Array,
      required: true,
    },
    disableFilter: {
      type: Boolean,
    },
    disableSearch: {
      type: Boolean,
    },
    dirty: {
      type: Boolean,
    },
  },
  methods: {
    onToggleInput () {
      this.updateFilters(this.filters);
    },
    updateFilters (newFilters) {
      this.$emit('change', newFilters);
    },
    clearFilters () {
      this.$emit('clear');
    },
    toggleCategorie (tag) {
      this.computedTags = {
        ...this.computedTags,
        [tag]: !this.computedTags[tag],
      };
      this.updateFilters(this.filters);
    },
  },
  computed: {
    computedTags: {
      get () { return this.filters.tags.reduce((obj, key) => ({ ...obj, [key]: true }), {}); },
      set (newCategories) { this.filters.tags = Object.keys(pickBy(newCategories, a => Boolean(a))); },
    },
  },
};
</script>

<template lang="pug">
div.filter-box.white.flex.flex-column.h-100
  div.mainbox.mb2.flex-auto.flex.flex-column.relative.h-100._collision(:class="{'-disabled': disableFilter }")
    header.fixedheader.pl3.pt3.top-0.left-0.right-0.z-2.flex.items-center.mt2.relative
      h1._title.white.b.f5.ttu.flex-auto.relative {{ $t('Filter') }}
        clear-style
          transition(enter-active-class="fadeIn animated-200", leave-active-class="fadeOut animated-200")
            button.clearallbtn.green.f7.fw6.br.pv2.pl2.absolute.top-50.translate-y--50.right-0(v-if="dirty", type="button", @click="clearFilters")
              span.v-mid {{ $t('Clear all') }}
              icon.w1.fill-inherit.v-mid.mh2(name="x")
    //- div.filtercontainer.absolute.absolute--fill.overflow-y-scroll
    scroll-element.flex-auto
      div.pt4.pb3.ph2
        div.difficulty.mb4
          h3.subtitle.white-70.mb2.f6.fw6.ph2 {{ $t('Difficulty') }}
          ul.flex.justify-between
            li.w-30
              pill-toggle.difficultybtn.pa1.w-100(v-model="filters.difficulty.easy", @input="onToggleInput")
                icon.w05.mr1(name="easy")
                span {{ $t('Easy') }}
            li.w-30
              pill-toggle.difficultybtn.pa1.w-100(v-model="filters.difficulty.medium", @input="onToggleInput")
                icon.w05.mr1(name="medium")
                span {{ $t('Med.') }}
            li.w-30
              pill-toggle.difficultybtn.pa1.w-100(v-model="filters.difficulty.hard", @input="onToggleInput")
                icon.w05.mr1(name="hard")
                span {{ $t('Hard') }}
        div.playermode.mb4
          h3.subtitle.white-70.mb2.f6.fw6.ph2 {{ $t('Players') }}
          ul.flex.justify-between
            li.w-48
              pill-toggle.playermodebtn.pa1.w-100(v-model="filters.playerMode.single", @input="onToggleInput")
                icon.playermodeicon.mr1.fill-inherit(name="singleplayer")
                span {{ $t('Single') }}
            li.w-48
              pill-toggle.playermodebtn.pa1.w-100(v-model="filters.playerMode.multi", @input="onToggleInput")
                icon.playermodeicon.mr1.fill-inherit(viewBox="0 0 15 11", name="multiplayer")
                span {{ $t('Multi') }}
        div.tagfilter.mb1
        h3.subtitle.white-70.mb2.f6.fw6.ph2(v-if="tags && tags.length") {{ $t('Tags') }}
        ul.taglist.flex.w-100.flex-wrap.justify-between(v-if="tags && tags.length")
          li.tagitem.w-48.mb2(v-for="tag in tags")
            pill-toggle.tagbtn.pa1.w-100(:value="computedTags[tag.id]", @input="toggleCategorie(tag.id)") {{ tag.text }}
  cta-style
    launcher-router-link.searchbtn._collision.bg-black-overlay.white.b.f5.pa2.tc.ttu(:to="{ name: 'games-search' }",  :class="{'-disabled': disableSearch }") {{ $t('Search') }}
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "styles/variables.css";
.filter-box {
  & .mainbox.-disabled > * {
    pointer-events: none;
    opacity: 0.5;
  }
  & .playermodeicon {
    height: 1.4ex;
  }
  & .mainbox {
    position: relative;
    background: var(--blackOverlay);
  }
}
</style>
